import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
import "./OrderList.css";
import OrderDetails from "./OrderDetails";
import PropTypes from "prop-types";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import Table from "../../core/pagination/datatable"; // Make sure this path is correct

const OrderList = ({ onViewOrder, dateFilter, onDateFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  // const { storeId } = useSelector((state) => state.user);
  const [orderedProducts] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading,] = useState(true);
  const [error] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const tableRef = useRef(null);
  const [showClearButton, setShowClearButton] = useState(false);
  const [datePickerKey, setDatePickerKey] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  
  // const apiBase = 
  //   process.env.REACT_APP_BASEURL || 
  //   window.__APP_CONFIG__?.API_BASE_URL || "";

  // const BASE_URL = apiBase;

  // Initialize date filter if not provided
  const [localDateFilter, setLocalDateFilter] = useState(
    dateFilter || {
      startDate: moment().subtract(30, 'days'),
      endDate: moment()
    }
  );
  
  // function to clear the date filter
  const clearDateFilter = () => {
    const defaultDateFilter = {
      startDate: moment().subtract(30, 'days'),
      endDate: moment()
    };
    
    setLocalDateFilter(defaultDateFilter);
    setShowClearButton(false);
    setDatePickerKey(prev => prev + 1); // Force re-render of DateRangePicker
    
    // Notify parent component if callback is provided
    if (onDateFilterChange) {
      onDateFilterChange(defaultDateFilter);
    }
  };

  // Scroll to top when component mounts or data changes
  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [filteredOrders, loading]);

  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A";
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString();
  // };

  // const parseDate = (dateString) => {
  //   if (!dateString) return null;
  //   return moment(dateString);
  // };

  // const fetchOrderedProducts = async () => {
  //   try {
  //     setLoading(true);
      // const response = await axios.get(
      //   `${BASE_URL}api/v1/Order/GetOrderedProduct`,
      //   { params: { storeId } }
      // );

  //     if (response.data?.data) {
  //       const transformedData = response.data.data.map((order) => {
  //         const productCount = order.products ? order.products.length : 0;
  //         const firstProductName =
  //           order.products && order.products.length > 0
  //             ? order.products[0].productName
  //             : "Unknown Product";

  //         return {
  //           ...order,
  //           createdAt: moment(order.createdAt).format("YYYY/MM/DD"),
  //           originalDate: parseDate(order.createdAt),
  //           totalAmount: `₹ ${order.totalAmount.toFixed(2)}`,
  //           productName: firstProductName,
  //           additionalProducts: productCount > 1 ? productCount - 1 : 0,
  //           totalQuantity: order.products
  //             ? order.products.reduce(
  //                 (sum, product) => sum + (product.quantity || 0),
  //                 0
  //               )
  //             : 0,
  //         };
  //       });
  //       setOrderedProducts(transformedData);
  //       setFilteredOrders(transformedData);
  //     }
  //   } catch (err) {
  //     setError(err.message);
  //     console.error("Error fetching ordered products:", err);
  //   } finally {
  //     setLoading(false);
  //     setRefreshing(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchOrderedProducts();
  // }, [storeId]);

  // Filter orders based on date range and search term
  useEffect(() => {
    let result = [...orderedProducts];
    
    // Apply date filter
    if (localDateFilter) {
      result = result.filter(order => {
        if (!order.originalDate) return false;
        
        return order.originalDate.isBetween(
          localDateFilter.startDate, 
          localDateFilter.endDate, 
          null, 
          '[]'
        );
      });
    }
    
    // Apply search filter
    if (searchTerm.trim()) {
      const query = searchTerm.toLowerCase().trim();
      result = result.filter(order => 
        (order.orderNumber && order.orderNumber.toLowerCase().includes(query)) ||
        (order.totalAmount && order.totalAmount.toString().toLowerCase().includes(query)) ||
        (order.productName && order.productName.toLowerCase().includes(query))
      );
    }
    
    setFilteredOrders(result);
  }, [orderedProducts, localDateFilter, searchTerm]);

  const handleDateRangeChange = (start, end) => {
    const newDateFilter = {
      startDate: moment(start),
      endDate: moment(end)
    };
    
    setLocalDateFilter(newDateFilter);
    setShowClearButton(true);
    
    // Notify parent component if callback is provided
    if (onDateFilterChange) {
      onDateFilterChange(newDateFilter);
    }
  };

  const handleViewDetails = (order) => {
    if (onViewOrder) {
      onViewOrder(order);
    } else {
      setSelectedOrder(order);
      setShowDetails(true);
    }
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
    setSelectedOrder(null);
  };

 const handleRefresh = () => {
  setRefreshing(true);
  // fetchOrderedProducts();
  setCurrentPage(1);
};


  if (loading && !refreshing) {
    return (
      <div className="d-flex justify-content-center my-4">
        {/* <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div> */}
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger">Error loading orders: {error}</div>
    );
  }

  const columns = [
    {
      title: "Order",
      dataIndex: "orderNumber",
      flex: 2,
      width: '15%',
      render: (text) => (
        <div>
          <strong>{text}</strong>
        </div>
      ),
      sorter: (a, b) => a.orderNumber.localeCompare(b.orderNumber),
    },
    {
      title: "Quantity",
      dataIndex: "totalQuantity",
      flex: 1,
      width: '10%',
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      flex: 1,
      width: '15%',
      sorter: (a, b) => a.originalDate - b.originalDate,
    },
    {
      title: "Total",
      dataIndex: "totalAmount",
      flex: 1,
      width: '15%',
      sorter: (a, b) => {
        const amountA = parseFloat(a.totalAmount.replace('₹ ', ''));
        const amountB = parseFloat(b.totalAmount.replace('₹ ', ''));
        return amountA - amountB;
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      flex: 1,
      width: '10%',
      render: (_, record) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => handleViewDetails(record)}
        >
          View Details
        </button>
      ),
    }
  ];

  // Create the empty text component for the Table
  const emptyText = (
    <div className="text-center py-4">
      <i className="ti ti-package fs-24 text-muted mb-2"></i>
      <h5>No orders found</h5>
      <p className="text-muted">
        {orderedProducts.length > 0 
          ? "No orders match your search criteria" 
          : "No product orders have been placed yet"}
      </p>
    </div>
  );

  return (
    <>
      <div
        ref={tableRef}
        className="modal-dialog modal-dialog-centered modal-lg"
        style={{ maxWidth: "95%" }}
      >
        <div className="modal-content" style={{ width: "100%" }}>
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title">Order List</h5>
            <button
              className="btn btn-sm btn-outline-primary d-flex align-items-center"
              onClick={handleRefresh}
              disabled={refreshing}
              style={{marginBottom:10}}
            >
              {refreshing ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Refreshing...
                </>
              ) : (
                <>
                  <i className="ti ti-refresh me-1"></i>
                  Refresh 
                </>
              )}
            </button>
          </div>
          <div className="modal-body">
            <div className="card table-list-card mb-0">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
                {/* Search Input - Left side */}
                <div className="search-input" style={{minWidth: '200px', maxWidth: '200px', flex: '1' }}>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Search orders..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                
                {/* Date Range Picker - Right side */}
                <div className="d-flex align-items-center gap-2">
                  <DateRangePicker
                    key={datePickerKey}
                    initialSettings={{
                      startDate: localDateFilter.startDate.toDate(),
                      endDate: localDateFilter.endDate.toDate(),
                      ranges: {
                        'Today': [moment().toDate(), moment().toDate()],
                        'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                        'Last 7 Days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                        'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
                        'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
                        'Last Month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
                      }
                    }}
                    onCallback={handleDateRangeChange}
                  >
                    <div
                      className="form-control d-flex align-items-center"
                      style={{
                        cursor: 'pointer',
                        background: '#fff',
                        minWidth: '220px',
                        height: '32px'
                      }}
                    >
                      <i className="ti ti-calendar me-2"></i>
                      <span className="flex-grow-1">
                        {localDateFilter.startDate.format('YYYY/MM/DD')} - {localDateFilter.endDate.format('YYYY/MM/DD')}
                      </span>
                    </div>
                  </DateRangePicker>
                  
                  {/* Clear Button - Only show when a custom date range is selected */}
                  {showClearButton && (
                    <button
                      className="btn btn-sm "
                      onClick={clearDateFilter}
                      style={{ height: '32px',padding:'0px' }}
                      title="Clear date filter"
                    >
                      <i className="ti ti-refresh"></i>
                    </button>
                  )}
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive" style={{ width: "100%", overflowX: "auto" }}>
                  <Table
                    columns={columns}
                    dataSource={filteredOrders}
                    loading={loading}
                    pagination={{ 
                      PageSize: pageSize,
                      current: currentPage,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      }
                    }}
                    scroll={{ x: 'max-content' }}
                    emptyText={emptyText}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Show order details modal when an order is selected */}
      {showDetails && (
        <OrderDetails order={selectedOrder} onClose={handleCloseDetails} />
      )}
    </>
  );
};

OrderList.propTypes = {
  onViewOrder: PropTypes.func,
  dateFilter: PropTypes.object,
  onDateFilterChange: PropTypes.func
};

OrderList.defaultProps = {
  onViewOrder: null,
  dateFilter: null,
  onDateFilterChange: null
};

export default OrderList;